import { create } from 'zustand';
import { STORAGE_KEYS } from '@/config/constants';

interface AuthState {
  uid: string | null;
  displayName: string;
  isAnonymous: boolean;
  bestScore: number;
  bestLevel: number;
  totalGames: number;
  ready: boolean;

  setUser: (data: { uid: string | null; displayName?: string | null; isAnonymous: boolean }) => void;
  setNickname: (name: string) => void;
  setBestScore: (score: number, level: number) => void;
  setProfile: (data: { nickname?: string; bestScore?: number; bestLevel?: number; totalGames?: number }) => void;
  setReady: (ready: boolean) => void;
}

const storedNickname =
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEYS.nickname) ?? '' : '';
const storedBest =
  typeof localStorage !== 'undefined'
    ? Number(localStorage.getItem(STORAGE_KEYS.bestScore) ?? '0')
    : 0;

export const useAuthStore = create<AuthState>((set) => ({
  uid: null,
  displayName: storedNickname,
  isAnonymous: true,
  bestScore: storedBest || 0,
  bestLevel: 0,
  totalGames: 0,
  ready: false,

  setUser: ({ uid, displayName, isAnonymous }) =>
    set((s) => ({
      uid,
      displayName: displayName || s.displayName,
      isAnonymous
    })),

  setNickname: (name) => {
    const trimmed = name.trim().slice(0, 20);
    localStorage.setItem(STORAGE_KEYS.nickname, trimmed);
    set({ displayName: trimmed });
  },

  setBestScore: (score, level) => {
    localStorage.setItem(STORAGE_KEYS.bestScore, String(score));
    set((s) => ({
      bestScore: Math.max(s.bestScore, score),
      bestLevel: Math.max(s.bestLevel, level)
    }));
  },

  setProfile: ({ nickname, bestScore, bestLevel, totalGames }) =>
    set((s) => ({
      displayName: nickname ?? s.displayName,
      bestScore: bestScore ?? s.bestScore,
      bestLevel: bestLevel ?? s.bestLevel,
      totalGames: totalGames ?? s.totalGames
    })),

  setReady: (ready) => set({ ready })
}));
